import {PlacedOrder, PlacedOrders} from "../models/PlacedOrder";

export interface PlacedOrdersChange {
    readonly type: ChangeType;
}

export enum ChangeType {
    REFRESH,
    ADD
}

export interface PlacedOrdersRefreshChange extends PlacedOrdersChange {
    readonly type: ChangeType.REFRESH;
    readonly orders: PlacedOrders;
}

export function isRefreshChange(change: PlacedOrdersChange): change is PlacedOrdersRefreshChange {
    return change.type === ChangeType.REFRESH;
}

export function placedOrdersRefreshChange(orders: PlacedOrders): PlacedOrdersRefreshChange {
    return {
        type: ChangeType.REFRESH,
        orders
    };
}

export interface PlacedOrdersAddChange extends PlacedOrdersChange {
    readonly type: ChangeType.ADD;
    readonly order: PlacedOrder;
}

export function isAddChange(change: PlacedOrdersChange): change is PlacedOrdersAddChange {
    return change.type === ChangeType.ADD;
}

export function placedOrdersAddChange(order: PlacedOrder): PlacedOrdersAddChange {
    return {
        type: ChangeType.ADD,
        order
    };
}
